import { ToasterService } from '@commons/services';

import { Injectable, NgZone } from '@angular/core';

import { Initializable } from './app-init.service';

import { EasyDebugDecorator } from '../../app/decorators/easy-debug.decorator';
import { BehaviorSubject } from 'rxjs';

export enum ConnectionStatusEnum {
  Online,
  Offline,
}

@Injectable({
  providedIn: 'root',
})
@EasyDebugDecorator
export class NetworkStatusService implements Initializable {
  private _networkStatus: number = ConnectionStatusEnum.Online;
  private networkStatusObs = new BehaviorSubject<boolean>(true);
  networkStatusObs$ = this.networkStatusObs.asObservable();

  get networkStatus(): number {
    return this._networkStatus;
  }

  set networkStatus(value: number) {
    this._networkStatus = value;
    this.networkStatusObs.next(value === ConnectionStatusEnum.Online);
  }

  offToastConf = {
    text: 'Tu es hors ligne : certaines actions sont indisponibles',
    bgcolor: 'var(--color-danger)',
    duration: '5000',
  };

  onToastConf = {
    text: 'Tu es de retour en ligne !',
    bgcolor: 'var(--color-success)',
    duration: '5000',
  };

  constructor(
    private ngZone: NgZone,
    private toasterService: ToasterService
  ) {
    this.networkStatus = navigator.onLine ? ConnectionStatusEnum.Online : ConnectionStatusEnum.Offline;
  }

  async init(): Promise<number> {
    this.networkStatus = navigator.onLine ? ConnectionStatusEnum.Online : ConnectionStatusEnum.Offline;
    this.initializeNetworkEvents();
    return this.networkStatus;
  }

  initializeNetworkEvents(): void {
    window.addEventListener('offline', () => {
      this.ngZone.run(() => {
        if (this.networkStatus === ConnectionStatusEnum.Online) {
          this.toasterService.create(this.offToastConf);
        }
        this.networkStatus = ConnectionStatusEnum.Offline;
      });
    });

    window.addEventListener('online', () => {
      this.ngZone.run(() => {
        if (this.networkStatus === ConnectionStatusEnum.Offline) {
          this.toasterService.create(this.onToastConf);
        }
        this.networkStatus = ConnectionStatusEnum.Online;
      });
    });
  }
}
